import { render, staticRenderFns } from "./AudioPlayer.vue?vue&type=template&id=4a1145de"
import script from "./AudioPlayer.vue?vue&type=script&lang=js"
export * from "./AudioPlayer.vue?vue&type=script&lang=js"
import style0 from "./AudioPlayer.vue?vue&type=style&index=0&id=4a1145de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports